import { queryOptions } from '@tanstack/react-query'
import { getMeOptions, STALE } from '@/shared/api'

/**
 * Живая сессия: кто вошёл и в какой компании.
 *
 * `retry: false` — 401 уже обрабатывает глобальный перехватчик (`shared/api/http.ts` →
 * `App.tsx`, уход на `/login`). Повторять запрос до отказа незачем: сам он не «поправится».
 *
 * Список компаний лежит НЕ здесь, а в `entities/company` — это отдельная сущность со своим
 * UI (аватар, карточка) и своей палитрой. Сессия знает только про ТЕКУЩУЮ компанию, потому что
 * та часть ответа `GET /me`.
 */
export function sessionQuery() {
  return queryOptions({
    ...getMeOptions(),
    staleTime: STALE.studio,
    retry: false,
  })
}
